import React from 'react'

const RecruitmentPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Recruitment Page</h1>
      <p>This is a placeholder for the Recruitment page.</p>
    </div>
  )
}

export default RecruitmentPage